




































import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import { QInput } from 'quasar'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import ContactGroupUpdate from 'src/graphql/contact_group/ContactGroupUpdate.gql'
import api from 'src/assets/api/gql'
import { ContactGroup } from 'src/graphql/types'

@Component({
  components: {
    DialogFullscreen
  }
})
export default class ContactButtonGroupAdd extends Vue {
  loading = false
  error = false
  name = ''
  group!: ContactGroup

  @Ref()
  readonly dialog!: DialogFullscreen

  @Ref()
  readonly input!: QInput

  @Watch('name')
  change () {
    this.error = false
  }

  edit (group: ContactGroup) {
    this.group = group
    this.name = this.group.name
    this.dialog.show()
    this.$nextTick(() => { this.input.focus() })
  }

  async save () {
    if (this.name.length) {
      this.loading = true
      const { data: { updateContactGroup } } = await api.mutate({
        query: ContactGroupUpdate,
        variables: {
          id: this.group.id,
          data: {
            name: this.name
          }
        }
      })
      this.loading = false
      if (updateContactGroup?.contactGroup) {
        this.group.name = updateContactGroup.contactGroup.name
        this.dialog.hide()
      } else {
        this.error = true
        this.$nextTick(() => { this.input.focus() })
      }
    }
  }
}
